import { render } from "./CompanyInfo.vue?vue&type=template&id=5fc7470c&scoped=true"
import script from "./CompanyInfo.vue?vue&type=script&lang=js"
export * from "./CompanyInfo.vue?vue&type=script&lang=js"

import "./CompanyInfo.vue?vue&type=style&index=0&id=5fc7470c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc7470c"]])

export default __exports__